export enum ReplacePlCharsSize {
    Uppercase = 1,
    Lowercase = -1,
    Normal = 0
}

export function replacePLChars(text: string, size: ReplacePlCharsSize = ReplacePlCharsSize.Normal): string {
    let response = text.normalize('NFD')
        .replace(/[\u200b-\u200f]/g, '')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\u0142/g, 'l');

    switch (size) {
        case ReplacePlCharsSize.Uppercase:
            response = response.toUpperCase();

            break;
        case ReplacePlCharsSize.Lowercase:
            response = response.toLowerCase();

            break;
    }

    return response;
}

export function trimLength(value: string, maxLength: number): string {
    const ellipsisSymbol = '...';

    if (value?.length > maxLength) {
        if (maxLength > ellipsisSymbol.length) {
            const shortValue = value.substring(0, maxLength - ellipsisSymbol.length);
            const words = shortValue.split(' ');

            if (words.length > 1) {
                return words.slice(0, words.length - 1).join(' ').replace(/[.,]+$/, '').trim() + ellipsisSymbol;
            }
        }

        return value.substring(0, maxLength).trim();
    }

    return value;
}
